module.exports = __webpack_public_path__ + "static/img/sf-express.81c3e2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/sf-express.png
// module id = luVz
// module chunks = 1 2